import { StreamRoleId } from "../dto/mediaAvailability";
import type { PlayableArtifact } from '../dto/playableItemDto';
import type { PlaybackQuality } from '../types/playbackQuality';

export function playableArtifactToQuality(artifact: PlayableArtifact): PlaybackQuality | null {
  switch (artifact.type) {
    case 'stream':
      if (artifact.streamSet.includes(StreamRoleId.LiveRecordHighresTs)) {
        return 'original-segmented';
      }
      if (artifact.streamSet.includes(StreamRoleId.LiveRecordAudioOnlyHighresTs)) {
        return 'original-segmented';
      }
      if (artifact.streamSet.includes(StreamRoleId.EditProxyFull)) {
        return 'edit-proxy-segmented';
      }
      if (artifact.streamSet.includes(StreamRoleId.LiveRecordWebproxyTs) || artifact.streamSet.includes(StreamRoleId.BrowsePreviewVideo)) {
        return 'web-proxy-segmented';
      }
      if (artifact.streamSet.includes(StreamRoleId.LiveRecordAudioOnlyProxyTs)) {
        return 'web-proxy-segmented';
      }
      return null;

    case 'flatHighRes':
      return 'original-flat';

    case 'flatEditProxy':
      return 'edit-proxy-flat';

    case 'flatWebProxy':
      return 'web-proxy-flat';

    case 'tams':
      // TAMS artifacts are built from the flows the producer tagged as
      // playback proxies (see resolveTamsPlayback / resolveTamsSourceFlows).
      return 'web-proxy-segmented';

    default:
      return null;
  }
}

